import { Controller } from "@hotwired/stimulus"

// Facilitação do formulário de link de venda de parceiro.
// - trava o preço (resolvido no servidor) e habilita o submit só quando há preço;
// - mostra/esconde campos conforme forma de pagamento e tipo de produto;
// - botão de preenchimento rápido de data (vencimento do contrato funerário).
// O preço e os termos definitivos são sempre validados no servidor. O parceiro
// paga o preço integral (sem financiamento; manutenção é a padrão do produto);
// no cartão/POS pode parcelar.
export default class extends Controller {
  static targets = [
    "partner", "product", "priceDisplay", "submit",
    "saleType", "method",
    "installmentsGroup", "downPaymentInstallments",
    "funeraryGroup",
    "usesGroup", "maxUses"
  ]

  static values = {
    url: String,
    maxInstallments: Number
  }

  connect() {
    this.refresh()
  }

  async refresh() {
    const partnerId = this.partnerTarget.value
    const productId = this.productTarget.value

    if (!partnerId || !productId) {
      this.renderPrice(null)
      return
    }

    try {
      const res = await fetch(`${this.urlValue}?partner_id=${partnerId}&product_id=${productId}`,
        { headers: { Accept: "application/json" } })
      this.applyMetadata(await res.json())
    } catch {
      this.renderPrice(null)
    }
  }

  applyMetadata(data) {
    if (data.max_installments) this.maxInstallmentsValue = data.max_installments

    this.renderPrice(data.price_formatted)

    // só mostra os campos de plano funerário para esse tipo de produto
    const funerary = data.product_type === "funerary_plan"
    this.toggle(this.funeraryGroupTargets, funerary)

    // sugere o tipo de venda conforme o produto (imediato/preventivo)
    if (this.hasSaleTypeTarget && data.acquisition_method) {
      this.saleTypeTarget.value = data.acquisition_method
    }

    if (this.maxInstallmentsValue > 0) {
      this.installmentInputs().forEach((i) => { i.max = this.maxInstallmentsValue })
    }

    this.applyMethodVisibility()
  }

  renderPrice(formatted) {
    const ok = Boolean(formatted)
    this.priceDisplayTarget.textContent = ok ? formatted : "Sem preço de parceiro para esta combinação"
    this.priceDisplayTarget.classList.toggle("text-green-800", ok)
    this.priceDisplayTarget.classList.toggle("text-red-600", !ok)

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !ok
      this.submitTarget.classList.toggle("opacity-50", !ok)
      this.submitTarget.classList.toggle("cursor-not-allowed", !ok)
    }
  }

  // forma de pagamento → parcelas só fazem sentido em cartão/POS
  applyMethodVisibility() {
    if (!this.hasMethodTarget) return
    const m = this.methodTarget.value
    const showInstallments = m === "credit_card" || m === "pos"
    this.toggle(this.installmentsGroupTargets, showInstallments)
    if (!showInstallments && this.hasDownPaymentInstallmentsTarget) {
      this.downPaymentInstallmentsTarget.value = 1
    }

    // Online (pix/cartão) = link reutilizável (max_uses). Presencial = venda única.
    const online = m === "pix" || m === "credit_card"
    this.toggle(this.usesGroupTargets, online)
    if (!online && this.hasMaxUsesTarget) this.maxUsesTarget.value = 1
  }

  changeMethod() { this.applyMethodVisibility() }

  // botão "+30 dias" (1º vencimento do contrato funerário)
  fillDate(event) {
    const field = event.params.field
    const days = Number(event.params.days || 30)
    const el = this.element.querySelector(`[name="partner_sale_link[${field}]"]`)
    if (!el) return
    const d = new Date()
    d.setDate(d.getDate() + days)
    el.value = d.toISOString().slice(0, 10)
  }

  // ---- helpers ----
  installmentInputs() {
    return Array.from(this.element.querySelectorAll(
      'input[name="partner_sale_link[down_payment_installments]"],' +
      'input[name="partner_sale_link[adhesion_installments]"]'
    ))
  }

  toggle(els, show) { els.forEach((e) => e.classList.toggle("hidden", !show)) }
}
